import { useSelector } from "react-redux";
import styles from "./index.module.scss";

export default function InstallCenters({
  title = "Установочные центры",
  isFarkop,
}) {
  const { contactsData } = useSelector((state) => state.contacts);

  return (
    <div>
      <h2 className={styles.Title}>{title}</h2>
      <div className={styles.InstallCenters}>
        {contactsData.SHOPS?.map((shop, i) => (
          <div key={i} className={styles.AdrBlock}>
            <div>Адрес:</div>
            <span dangerouslySetInnerHTML={{ __html: shop["~ADR"] }} />
            {shop.WORK_TIME && (
              <>
                <div>Режим работы:</div>
                <span>{shop?.WORK_TIME}</span>
              </>
            )}
            {isFarkop && <a href={`/shops/${shop.ID}`}>Подробнее о центре</a>}
          </div>
        ))}
      </div>
    </div>
  );
}
